/** 
  * @class Base Resource Class for Images
  * @extends SSResource
  * @param {Object} config An options hash with settings for the Resource
  */
import SSResource from './00-slideshare_resource';

function SSImageResource(config){
  if (typeof config === 'undefined'){
    return;
  }
  if (config.availableSizes){
    this.imageVersions = this._mapSizesToVersions(config.availableSizes);
    // imageVersions is a temporary variable from which suffixes are generated. 
    // Bad design having it as an instance property
    // Need to come back and fix this
    
    delete(config.availableSizes);
    
    // conversionVersion comes in on fallback mode as html's conversion version.
    // Hack to ignore that is to check for availableSizes
    // in case not available, delayedInitialize sets it
    this._setUrlGenerator(config.is_private);
  } else {
    this.loadBlocked = true;
  }
  
  this.contentWidth = config.contentWidth;
  delete(config.contentWidth);
  
  SSResource.call(this, config);
  
  this.RETRY_WAIT_TIME = 1000;
  delete(this.imageVersions); // redesign so this property is not needed
}

SSImageResource.prototype = new SSResource();

/** 
  * Configures the resource based on the resourceType
  */
SSImageResource.prototype._initResourceConfig = function(){
  // htmlv2 changes. Not ideal design, but this method needs imageVersions. 
  // returning if not available for now. 
  // ideally this should not even be called
  
  if (this.imageVersions === undefined){
    return;
  }
  var resourceTemplate = this.resourceTemplate;
  this.indexString = this.config.indexGenerator(this.config.realIndex, resourceTemplate.digitLength);
  this.suffixes = this._getSuffixes(); // try to avoid this and pass in imagesizes as a parameter
  this.cacheable = resourceTemplate.cacheable;
  this.retries = resourceTemplate.retries || 0;
  this.isCritical = resourceTemplate.isCritical;
  this.privateUrls = {};  

};

/**
  * @private
  * Constructs and returns a url when a suffix is provided, ie a url for the appropriate version
  */
SSImageResource.prototype._getUrl = function(versions){
  return versions[versions.length - 1].url;
};

// save size>quality maps for best size fit calculations
// use a better name?
SSImageResource.prototype._mapSizesToVersions = function(sizes){
  var imageVersions = [];
  for (var width in sizes){
    if (!sizes.hasOwnProperty(width)){
      continue;
    }
    imageVersions[parseInt(width,10)] = sizes[width];
  }
  return imageVersions;
};

// bad name. do not use set/get. code reviewers?
SSImageResource.prototype._setUrlGenerator = function(is_private){  
  if(is_private){
    this.useTimeStamp = false;
    this._generateUrl = this._generatePrivateUrl;
  }else{
    this._generateUrl = this._generateUrl; 
  }    
};

SSImageResource.prototype.delayedInitialize = function(config){
  this.imageVersions = this._mapSizesToVersions(config.availableSizes);
  this.contentWidth = config.contentWidth;
  this._setUrlGenerator(config.is_private);
  if(!config.is_private){
    this.ready();
  }
};

SSImageResource.prototype.ready = function(){
  this._initResourceConfig();
  delete(this.imageVersions);
  this.loadBlocked = false;
  if (this.status === 'loading'){
    this.load();
  }
};  
  

/**
  * @private
  * Tries to load the resource
  */
SSImageResource.prototype._tryLoad = function(containerWidth){
  containerWidth = containerWidth || this.config.playerWidth;
  var width = this._getAppropriateWidth(containerWidth);
  var suffix = this.suffixes[width];
  var url;
  url = this._getUrl(suffix);

  if (width === this.currentWidth && suffix.status!== 'initialized'){
    return;
  }
  
  if (suffix.status === 'failed'){
    (this.versionErrorInternalHandler(width, url))();
    return;
  }
  
  this.currentWidth = width;
  
  if (suffix.status === 'loading'){
    return;
  }
  
  if (suffix.status === 'loaded'){
    (this.versionLoadedInternalHandler(width, url))();
    return;
  }
  
  suffix.status = 'loading';
  if (suffix.startTime === undefined){
    suffix.startTime = (new Date()).getTime();
  }
  if(this.config.show_image_player){
    var imageEle = $('.slide').eq(this.config.realIndex - 1).children();
    url = this.config.isFullScreen ? imageEle.data('full') : imageEle.data('normal');
  }
  var img = new Image();
  $(img).bind(
    'load',
    this.versionLoadedInternalHandler(width, url)
  ).bind(
    'error',
    this.versionErrorInternalHandler(width)
  );
  if(url !== undefined) {
    img.src = url;
  }
};

/**
  * EventHandler factory for when version finishes loading successfully
  * @param {Number} width The width for which the version load completed
  * @param {String} url The url that was successfully loaded
  * @private
  */
SSImageResource.prototype.versionLoadedInternalHandler = function(width, url){
  var that = this;
  return function(data){
    that.suffixes[width].status = 'loaded';

    if (that.status === 'loading'){
      // if this is the first successfully loaded version, then fire a resourceloaded event
      that.url = url;
      (that.resourceLoadedInternalHandler())(); // call the resourceloaded event
    } else if (that.status === 'cached' && width === that.currentWidth){ // this should be in an else block
      // if this is not the first one, and if this is the current one, then fire a versionloaded event
      that.url = url;
      $.slideshareEventManager.trigger('currentversionloaded', {
        index : that.config.slideIndex,
        resourceKey : that.resourceKey
      });
    }
  };
};

/**
  * EventHandler factory for when the version fails to load
  *   Retries version.retries number of times in case of failure before giving up
  * @param {Number} width The width for which the version load failed
  * @private
  */
SSImageResource.prototype.versionErrorInternalHandler = function(width){
  var that = this;
  return function(data){
    var suffix = that.suffixes[width];
    // retry version as many times as allowed.
    var startTime = suffix.startTime;
    var elapsedTime = (new Date()).getTime() - startTime;
    var retries = suffix.retries;
    if (retries > 0 && elapsedTime < that.TIMEOUT_LIMIT){
      retries = retries - 1;
      suffix.retries = retries;
      suffix.status = 'initialized';
      setTimeout(function(){
        that._tryLoad();
      },that.RETRY_WAIT_TIME);
      
    } else {
      // if retry expired for version, then mark as failed
      suffix.status = 'failed';
      
      // if resource is loading and is the current version then fire a resource load failed 
      //   if no other resource is available
      // dont do anything if resource already is loaded. 
      //   getUrl will return alternate url if current url is failed
      
      if(that.status === 'loading' && width === that.currentWidth){
        // if the version required is the current one and no other versions are available as ready, 
        //   then fire a resourceloaderror
        var alternateResourceAvailable = false;
        var resWidth;
        for (resWidth in that.suffixes){
          var alternateSuffix = that.suffixes[width];
          if (alternateSuffix.status === 'loading' || alternateSuffix.status == 'loaded' ){
            alternateResourceAvailable = true;
          }
        }
        if (!alternateResourceAvailable){
          (that.resourceErrorInternalHandler())(); // call the resourceerror event
        }
      } 
      // if you want to fire a versionloaderror, create an else block here and do it.
      // condition is retries == 0 and !(that.status === loading && width === that.currentWidth)
    }
  };
};

/**
  * EventHandler factory for when resource finishes loading successfully
  * @private
  */
SSImageResource.prototype.resourceLoadedInternalHandler = function(){
  var that = this;
  return function(data){
    $.slideshareEventManager.trigger('resourceloaded', {
      index : that.config.slideIndex,
      resourceKey : that.resourceKey      
    });
  };
};

/**
  * Returns the resource content for use by the Slide
  */
SSImageResource.prototype.getContent = function(){
  var suffix = this.suffixes[this.currentWidth];
  if (suffix.status === 'loaded'){
      return this.url;
  }
  
  var width;
  for(width in this.suffixes){
    suffix = this.suffixes[width];
    if (suffix.status === 'loaded'){
      const url = this._getUrl(suffix);
      return url;
    }
  }
  return this.url;
};

/**
  * Returns the appropriate width(ie, the version) to load when a container size is passed in
  * @param {Number} playerWidth The container size
  * @return {Number} returns appropriate width from available width versions
  */
SSImageResource.prototype._getAppropriateWidth = function(playerWidth){

  // calculate imagesize to be laoded
  var i, width, prevWidth;
  var suffixes = this.suffixes;
  var sortedWidths = [];
  var retinaScreenThreshold = 426;
  var retinaDefaultSize = 638;

  for(width in suffixes){
    width = parseInt(width,10);
    if (!suffixes.hasOwnProperty(width)) {
      continue;
    }
    
    sortedWidths.push(width);
  }

  sortedWidths.sort(function(a, b) {
    return a - b;
  });

  // Force load of higher res images for mobile retina screens
  if(playerWidth < retinaScreenThreshold && window.devicePixelRatio >= 2) {
    playerWidth = retinaDefaultSize;
  }

  for(i=0; i< sortedWidths.length; i++){
    width = sortedWidths[i];
    prevWidth = width;
    if(playerWidth <= width) {
      return width;
    }
  }
  return prevWidth;

};

export default SSImageResource;
